export const DAY_MILLISECOND = 60 * 60 * 24 * 1000; // 86400000

export const HOUR_MILLISECOND = 60 * 60 * 1000;
